package ui.screens.section.footer

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import ui.screens.section.footer.composable.Quote

@Composable
fun WeddingClosing(textColor: Color) {
    Column(horizontalAlignment = Alignment.CenterHorizontally) {
        Text(
            "Merupakan suatu kehormatan dan kebahagiaan bagi kami, apabila Bapak/Ibu/Saudara/i berkenan hadir dan memberikan doa restu. Atas kehadiran dan doa restunya, kami mengucapkan terima kasih.",
            modifier = Modifier
                .padding(start = 32.dp, end = 32.dp),
            style = MaterialTheme.typography.titleSmall.copy(
                fontSize = 16.sp,
                textAlign = TextAlign.Center
            ),
            color = textColor,
        )
        Quote(
            text = "Eva & Danu",
            modifier = Modifier.padding(vertical = 32.dp, horizontal = 24.dp)
        )
    }
}